export default __webpack_public_path__ + "static/media/Untitled-1-03.cc4867bd.png";